module.exports = __webpack_public_path__ + "static/media/icon_share_linkedin.b21c1d20.svg";